import tns from "@/lib/tiny-slider/tiny-slider.js";

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.multi-purpose-widget').forEach(function (widget) {
        var containerEl = widget.querySelector('.mpw-slider');
        if (!containerEl) return;
        var slider = tns({
            container: containerEl,
            items: 1,
            slideBy: 1,
            nav: false,
            controls: false,
            autoplay: false,
            speed: 300,
            loop: false
        });

        var prev = widget.querySelector('.left-arrow') || widget.querySelector('.slick-prev');
        var next = widget.querySelector('.right-arrow') || widget.querySelector('.slick-next');
        if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('prev'); });
        if (next) next.addEventListener('click', function (e) { e.preventDefault(); slider.goTo('next'); });

        widget.querySelectorAll('.mobile-mpw-nav').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var topEl = widget.querySelector('.mpw-slider');
                if (topEl) {
                    var top = topEl.getBoundingClientRect().top + window.pageYOffset - 50;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                }
            });
        });
    });
});


